<template>
    <el-dialog title="발주 추가"
               :visible="true"
               width="720px"
               :close-on-click-modal="false"
               :before-close="close">
        <div v-loading="isLoading">
            <el-row>
                <el-col v-if="!art">
                    <h2 class="page-title">1. 작품 검색</h2>

                    <el-input type="text"
                              class="art-search-input"
                              placeholder="작품ID 를 적어주세요."
                              v-model="artId"
                              maxlength="36"
                              show-word-limit
                              @keydown.enter.native="getArt"/>
                    <el-button type="primary"
                               circle
                               @click.prevent="getArt"><i class="el-icon-search"></i>
                    </el-button>
                </el-col>
                <el-col v-else>
                    <h2 class="page-title">1. 작품 검색 <i class="el-icon-check"></i></h2>

                    <el-input type="text"
                              class="art-search-input"
                              placeholder="작품ID 를 적어주세요."
                              v-model="art.artId"
                              readonly
                              disabled/>
                    <el-button type="success"
                               circle><i class="el-icon-check"></i>
                    </el-button>
                </el-col>
            </el-row>

            <el-row v-if="art">
                <el-col class="art-image-wrapper">
                    <div class="image-item"
                         v-for="resource in resultCoverResourceList"
                         :key="resource.publicPath">
                        <img :src="$S3_PREFIX + resource.publicPath"
                             :alt="resource.resourceType"/>
                    </div>
                </el-col>
            </el-row>

            <el-row v-if="art">
                <el-col class="order-wrapper">
                    <h2 class="page-title">2. 발주 수량 입력</h2>

                    <ul>
                        <li class="order-item">
                            <div class="area--size">
                                <h4>사이즈</h4>
                            </div>
                            <div class="area--amount">
                                <h4>수량</h4>
                            </div>
                            <div class="area--price">
                                <h4>소계</h4>
                            </div>
                        </li>
                        <li v-for="(option, index) in optionList"
                            :key="index"
                            class="order-item">
                            <div class="area--size">
                                <el-select v-model="option.sizeName"
                                           placeholder="사이즈 선택"
                                           @change="calculatePrice">
                                    <el-option v-for="size in productSizeList"
                                               :key="size.sizeName"
                                               :label="size.sizeName"
                                               :value="size.sizeName"
                                               :disabled="optionList.some(o => o.sizeName === size.sizeName)">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="area--amount">
                                <el-input-number v-model="option.amount"
                                                 :min="1"
                                                 :max="1000"
                                                 @change="calculatePrice"/>
                            </div>
                            <div class="area--price">
                                {{option.price | numberWithComma}}원
                            </div>
                            <el-button type="danger"
                                       icon="el-icon-delete"
                                       circle
                                       @click.prevent="removeOption(index)"/>
                        </li>
                        <li class="order-item">
                            <div class="area--size">
                                <el-button type="success"
                                           size="medium"
                                           @click.prevent="addOption"><i class="el-icon-plus"></i> 추가
                                </el-button>
                            </div>
                            <div class="area--amount area--amount--right">
                                <h3>총계</h3>
                            </div>
                            <div class="area--price">
                                <h3>{{totalPrice | numberWithComma}}원</h3>
                            </div>
                        </li>
                    </ul>
                </el-col>
            </el-row>
        </div>

        <div slot="footer"
             v-loading="isLoading2"
             class="dialog-footer">
            <el-button type="danger"
                       @click="close">취소
            </el-button>
            <el-button v-if="art"
                       type="primary"
                       @click="apply">발주
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';
    import {ART_RESOURCE_TYPE} from '@/const';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24CreateOrderModal',
        data() {
            return {
                isLoading: false,
                isLoading2: false,

                artId: '',

                art: null,
                optionList: [],
                totalPrice: 0,
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },

            resultCoverResourceList() {
                return this.art.resourceList.filter(r => r.resourceType === ART_RESOURCE_TYPE.RESULT_COVER) || [];
            },
            basePrice() {
                return this.art?.product.basePrice;
            },
            productSizeList() {
                return this.art?.product.sizeList || [];
            },
        },
        methods: {
            async getArt() {
                try {
                    this.isLoading = true;
                    const {data: art} = await PrintingDiyRepository.getPartnerArt(this.mall.mallId, this.artId, this.authToken);
                    this.art = art;
                    this.addOption();
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.artId = '';
                    this.isLoading = false;
                }
            },
            async createOrder(order) {
                try {
                    this.isLoading2 = true;
                    await PrintingDiyRepository.postPartnerOrder(this.mall.mallId, order, this.authToken);
                    this.$message.success('발주되었습니다.');
                    this.$emit('apply');
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading2 = false;
                }
            },

            addOption() {
                this.optionList.push({
                    sizeName: null,
                    amount: 1,
                    price: 0,
                });
            },
            removeOption(index) {
                this.optionList = this.optionList.filter((o, i) => i !== index);
                this.calculatePrice();
            },
            calculatePrice() {
                let totalPrice = 0;
                this.optionList = this.optionList.map(option => {
                    let price = 0;
                    const size = this.productSizeList.find(size => size.sizeName === option.sizeName);
                    if (size) {
                        price = (this.basePrice + size.additionPrice) * option.amount;
                    }

                    totalPrice += price;
                    return {
                        ...option,
                        price,
                    };
                });

                this.totalPrice = totalPrice;
            },

            async apply() {
                const order = {
                    artId: this.art.artId,
                    optionList: this.optionList
                                    .filter(o => !!o.sizeName)
                                    .map(option => ({sizeName: option.sizeName, amount: option.amount})),
                };

                if (order.optionList.length === 0) {
                    this.$message.warning('발주 수량을 입력해주세요.');
                    return;
                }

                await this.createOrder(order);
            },

            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .page-title {
        margin-bottom: 20px;

        i {
            color: #67C23A;
        }
    }

    .art-search-input {
        display: inline-block;
        width: 360px;
        margin-right: 10px;
    }

    .art-image-wrapper {
        width: 100%;
        margin: 0 10px;

        .image-item {
            width: 50%;
            display: inline-block;

            img {
                width: 100%;
            }
        }
    }

    .order-wrapper {
        margin-top: 40px;

        .order-item {
            width: 100%;
            border-bottom: 1px dashed #ddd;
            padding: 10px;

            &:last-child {
                border-bottom: 0;
            }

            .area--size {
                display: inline-block;
                width: 240px;
            }

            .area--amount {
                display: inline-block;
                width: 220px;
            }

            .area--amount--right {
                text-align: right;
            }

            .area--price {
                text-align: right;
                display: inline-block;
                width: 140px;
                margin-right: 20px;
            }
        }
    }
</style>